const WebClient = require("../utils/web-client");
const SnackbarActions = require("../actions/snackbar");
const Push = require("react-router-redux").push;

exports.requestPasswordReset = email => {
    return dispatch => {
        return WebClient.post(
            "/users/request-reset",
            { email },
            { responseType: "text" }
        )
            .then(({ data, status }) => {
                dispatch(
                    SnackbarActions.messageSnackbar(
                        "Password reset email successfully sent!"
                    )
                );
                return dispatch(Push("/login"));
            })
            .catch(err => {
                let errMessage = "Unable to reset password. Please try again";

                if (typeof err.response !== "undefined") {
                    errMessage = err.response.data.message;
                }

                return dispatch(SnackbarActions.messageSnackbar(errMessage));
            });
    };
};

exports.resetPassword = (email, newPassword, resetToken) => {
    return dispatch => {
        return WebClient.post(
            "/users/reset-password",
            { email, newPassword, resetToken },
            { responseType: "text" }
        )
            .then(({ data, status }) => {
                dispatch(
                    SnackbarActions.messageSnackbar(
                        "Password successfully reset!"
                    )
                );
                return dispatch(Push("/login"));
            })
            .catch(ignoreErr => {
                return dispatch(
                    SnackbarActions.messageSnackbar(
                        "Error resetting email, please try again!"
                    )
                );
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/reset-password.js